// Module
var code = `<ul class="js-checkbox-group-container" 
    style="position:absolute;overflow:hidden;margin:0;padding:0;{{>position}}">
    {{#.dataArray}}
        <li><terceraCheckBox text={{.text}} checked="{{.checked}}"/></li>
    {{/}}
</ul>`;
// Exports
export default code;